// Section clicks + views -> GTM "GA4event" pass-through; clicks also tag Clarity. Sitewide.
(function () {
  if (window.Shopify && Shopify.designMode) return;
  const template = (document.currentScript && document.currentScript.dataset.template) || 'page';
  const theme = window.Shopify && Shopify.theme;
  const live = !!(theme && theme.role === 'main');
  const main = document.getElementById('MainContent');

  // Readable names: "Collection: Sleepwear / 04 Product grid", "Home / Header topbar"
  const readable = (s) => s.replace(/[-_]+/g, ' ').trim().replace(/[a-z]/i, (c) => c.toUpperCase());
  const [type, suffix] = template.split('.');
  const [base, sub] = type.split('/');
  const pageName = { index: 'Home', 'list-collections': 'All collections', customers: 'Account' }[base] || readable(base);
  const detail = suffix || (sub !== 'account' && sub);
  const templateName = detail ? `${pageName}: ${readable(detail)}` : pageName;

  window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
  // Clarity only hears from the published theme; previews just log, like the GA4 payloads
  const toClarity = (...args) => (live ? clarity(...args) : console.debug('[section-tracking]', 'clarity', ...args));
  if (theme && theme.name) toClarity('set', 'theme', theme.name.split('/').pop());
  toClarity('set', 'page_type', pageName);
  toClarity('set', 'template', templateName);

  const clean = (s) => (s || '').replace(/\u2060/g, '').replace(/\s+/g, ' ').trim().slice(0, 80);

  const area = (section) => {
    if (main && section.parentElement === main) {
      const position = [...main.children].filter((c) => c.classList.contains('shopify-section')).indexOf(section) + 1;
      return String(position).padStart(2, '0');
    }
    const group = section.className.match(/shopify-section-group-([\w-]+?)-group/);
    return group ? group[1] : 'other';
  };
  const parts = (section) => {
    const where = area(section);
    // Drops the editor's random 6-char code (hand-named ffsale, slider stay) and a repeated group name
    const what = section.id.split('__').pop().replace(/_(?!ffsale$|slider$)[A-Za-z0-9]{6}$/, '').replace(new RegExp(`^${where}(?:[-_]|$)`), '');
    return [where, what];
  };
  const categoryOf = (section) => {
    const [where, what] = parts(section);
    return `${templateName} / ${readable(`${where} ${what}`)}`;
  };
  // Clarity funnel steps, a short stable list: homepage slots, header, collection sub-category slider
  const stepOf = (section) => {
    const [where, what] = parts(section);
    if (pageName === 'Home' && /^\d+$/.test(where)) return `Home slot ${where}`;
    if (where === 'header') return readable(`${where} ${what}`);
    if (pageName === 'Collection' && what === 'collection_list_slider') return 'Collection slider';
    return '';
  };

  const send = (name, category, label, url) => {
    const payload = {
      event: 'GA4event',
      'ga4-event-name': name,
      'ga4-event-p1-name': 'event_category',
      'ga4-event-p1-value': category,
      'ga4-event-p2-name': 'event_label',
      'ga4-event-p2-value': label,
      'ga4-event-p3-name': 'link_url',
      'ga4-event-p3-value': url,
    };
    if (live) (window.dataLayer = window.dataLayer || []).push(payload);
    else console.debug('[section-tracking]', payload);
  };

  document.addEventListener(
    'click',
    (e) => {
      const el = e.target.closest && e.target.closest('a[href], button, [role="button"]');
      if (!el) return;
      const section = el.closest('.shopify-section');
      if (!section) return;

      const category = categoryOf(section);
      const href = el.getAttribute('href') || '';
      const hrefs = [...new Set([...section.querySelectorAll('a[href]')].map((a) => a.getAttribute('href')))];
      const slot = href ? hrefs.indexOf(href) + 1 : '-';
      let path = '';
      if (href) {
        const url = new URL(href, location.origin);
        [...url.searchParams.keys()].filter((k) => /^(pr_|_)/.test(k)).forEach((k) => url.searchParams.delete(k)); // Shopify rec/search tracking params
        path = url.origin === location.origin ? url.pathname + url.search : url.href;
      }

      toClarity('event', 'section_click');
      toClarity('set', 'section_click', category);
      const step = stepOf(section);
      if (step) toClarity('event', `Click: ${step}`);
      send('section_click', category, `${slot} ${clean(el.innerText || el.getAttribute('aria-label'))}`, path);
    },
    true
  );

  // Views: main + footer sections, once per page, after 1s at half visible (or half the screen).
  const heading = (section) => {
    const h = section.querySelector('h1, h2, h3');
    return h ? clean(h.innerText) : '';
  };
  const timers = new Map();
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const section = entry.target;
        const seen =
          entry.isIntersecting &&
          entry.boundingClientRect.height > 0 &&
          (entry.intersectionRatio >= 0.5 || entry.intersectionRect.height >= window.innerHeight / 2);
        if (seen && !timers.has(section)) {
          timers.set(
            section,
            setTimeout(() => {
              io.unobserve(section);
              send('section_view', categoryOf(section), heading(section), '');
            }, 1000)
          );
        } else if (!seen && timers.has(section)) {
          clearTimeout(timers.get(section));
          timers.delete(section);
        }
      });
    },
    { threshold: Array.from({ length: 21 }, (_, i) => i / 20) }
  );
  document.querySelectorAll('.shopify-section').forEach((s) => {
    if ((main && s.parentElement === main) || s.classList.contains('shopify-section-group-footer-group')) io.observe(s);
  });

  // Drawers and modals (cart, Quick View, mobile menu, popups): every open counts.
  const isModal = (el) =>
    typeof ModalComponent !== 'undefined' ? el instanceof ModalComponent : /-(drawer|modal)$/.test(el.localName);
  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      const el = m.target;
      if (m.oldValue !== null || !el.hasAttribute('open') || !isModal(el)) return;
      const section = el.closest('.shopify-section');
      send('section_view', section ? categoryOf(section) : `${templateName} / ${readable(`overlay ${el.id || el.localName}`)}`, 'open', '');
    });
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'], attributeOldValue: true });
})();
